import * as msal from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: window._env_.REACT_APP_ADAL_CLIENT_ID || process.env.REACT_APP_ADAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${window._env_.REACT_APP_ADAL_TENANT || process.env.REACT_APP_ADAL_TENANT}`,
    redirectUri: window._env_.REACT_APP_ADAL_REDIRECT_URI || process.env.REACT_APP_ADAL_REDIRECT_URI,
    postLogoutRedirectUri: window._env_.REACT_APP_ADAL_POST_LOGOUT_REDIRECT_URI || process.env.REACT_APP_ADAL_POST_LOGOUT_REDIRECT_URI
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case msal.LogLevel.Error:
            console.error(message);
            return;
          case msal.LogLevel.Info:
            console.info(message);
            return;
          case msal.LogLevel.Verbose:
            console.debug(message);
            return;
          case msal.LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

export const loginRequest = {
    scopes: (window._env_.REACT_APP_ADAL_SCOPE || process.env.REACT_APP_ADAL_SCOPE || "").split(" ").filter(s => s),
    prompt: "select_account"
};

export const msalInstance = new msal.PublicClientApplication(msalConfig);

let initPromise = null;

export const initializeMsal = async () => {
    if (!initPromise) {
        initPromise = msalInstance.initialize();
    }
    return initPromise;
};
